<template>
  <div class="onlineMessage" v-loading="loading">
    <!--贴片-->
    <patch :data="data" />
    <div class="indexContainer">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"><i class="iconfont icon-shouye"></i> {{this.breadcrumbHome}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{parentTitle}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{activeTitle}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="indexContainer" style="padding:0">
        <el-divider class="indexTitle">
          <div class="indexTitleMain">
            <h3 v-if="languageId = 1">{{activeTitle ? activeTitle : ''}}</h3>
            <br />
            <h4>{{this.summary}}</h4>
          </div>
        </el-divider>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item style="width:100%; text-align:right">
            <el-button type="danger" @click="viewReply()">{{formInfo.btnShowReply}}</el-button>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="name" :label="formInfo.name" class="lilineForm" :rules="[
                  { required: true, message: formInfo.namePlaceholder, trigger: 'blur' }
                ]">
                <el-input v-model="form.name" :placeholder="formInfo.namePlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="formInfo.phone" prop="phone" class="lilineForm" :rules="[
                  { required: true, message: formInfo.phonePlaceholder, trigger: 'blur' }
                ]">
                <el-input v-model="form.phone" :placeholder="formInfo.phonePlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="formInfo.email" prop="email" class="lilineForm" :rules="[
                  { required: true, message: formInfo.emailPlaceholder, trigger: 'blur' }
                ]">
                <el-input v-model="form.email" :placeholder="formInfo.emailPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item :label="formInfo.address" prop="address" class="lilineForm" :rules="[
                  { required: true, message: formInfo.addressPlaceholder, trigger: 'blur' }
                ]">
                <el-input v-model="form.address" :placeholder="formInfo.addressPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="formInfo.category" prop="categoryId" class="lilineForm" :rules="[
                  { required: true, message: formInfo.categoryPlaceholder, trigger: 'change' }
                ]">
                <el-select v-model="form.categoryId" :placeholder="formInfo.categoryPlaceholder">
                  <el-option v-for="(item, index) in messageTypeList" :key="index" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="formInfo.title" prop="title" class="lilineForm" :rules="[
              { required: true, message: formInfo.titlePlaceholder, trigger: 'blur' }
            ]">
            <el-input v-model="form.title" :placeholder="formInfo.titlePlaceholder" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="formInfo.content" prop="content" class="lilineForm" :rules="[
              { required: true, message: formInfo.contentPlaceholder, trigger: 'blur' }
            ]">
            <el-input type="textarea" :rows="5" v-model="form.content" :placeholder="formInfo.contentPlaceholder" maxlength="1500" show-word-limit>
            </el-input>
          </el-form-item>
          <el-row>
            <el-col :xs="16" :sm="21" :md="21">
              <el-form-item :label="formInfo.filePath" class="lilineForm">
                <el-input v-model="fileName" :placeholder="formInfo.filePathPlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="8" :sm="3" :md="3" v-if="isShowBtn === 1">
              <el-button type="danger" class="uploadBtn" @click="handleUpload">{{formInfo.btnUpload}}</el-button>
            </el-col>
            <el-col :xs="8" :sm="3" :md="3" v-else style="padding-top: 40px">
              <upload ref="upload" @fileData="getFile" :code="form.verificationCode" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="formInfo.captcha" prop="verificationCode" class="lilineForm verificationCode" :rules="[
                  { required: true, message: formInfo.captchaPlaceholder, trigger: 'blur' }
                ]">
                <el-input v-model="form.verificationCode" :placeholder="formInfo.captchaPlaceholder"></el-input>
                <img :src="src" alt="" height="40" />
                <el-button type="danger" @click="handelChange">{{formInfo.btnReplace}}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="subBtn">
          <el-button type="danger" @click="subClick()">{{formInfo.btnSubmit}}</el-button>
          <el-button type="info" plain @click="reset()">{{formInfo.btnReset}}</el-button>
        </el-row>
      </div>
    </div>
    <submit-dig ref="submitDig" />
    <view-reply ref="viewReply" />
  </div>
</template>
<script>
import { getConfig } from '@/utils/oss'
import { getCategory, saveMessage } from '@/api/onlineMessage.js'
import { getCaptcha, getStsInfo } from '@/api/common.js'
import { getModule, getContent } from '@/api/inner.js'
import Patch from '../common/components/patch.vue'
import SubmitDig from './components/submitDig'
import ViewReply from './components/viewReply'
import Upload from '@/components/common/components/upload.vue'
export default {
  name: 'ONLINEMESSAGE',
  components: { Patch, SubmitDig, ViewReply, Upload },
  data() {
    return {
      loading: false,
      token: '',
      src: require('../../assets/logo.jpg'),
      isShowBtn: 1,
      fileName: '',
      parentTitle: '',
      activeTitle: '',
      formInfo: {},
      form: {
        name: '',
        phone: '',
        email: '',
        address: '',
        categoryId: '',
        title: '',
        content: '',
        filePath: '',
        fileUrl: '',
      },
      messageTypeList: [],
      rules: {
        name: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
        phone: [{ message: '请输入联系方式', trigger: 'blur' }],
        email: [{ message: '请输入电子邮箱', trigger: 'blur' }],
        address: [{ message: '请输入您的详细地址', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择留言类别', trigger: 'change' }],
        title: [{ required: true, message: '请输入您的留言主题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
        verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      data: [],
      breadcrumbHome: '',
      languageId: '',
      summary: '',
    }
  },
  created() {
    this.isShowBtn = 1
    this.getData()
    this.getCode()
    this.getModule()
    this.getContent()
    document.title = localStorage.getItem('name')
    // this.breadcrumbHome  =  localStorage.getItem('breadcrumbHome')
    this.breadcrumbHome = this.$store.getters.base.breadcrumbHome || ''
    let head = document.getElementsByTagName('head')
    let meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', localStorage.getItem('keywords'))
    if (localStorage.getItem('description')) {
      document.querySelector('meta[name="description"]').setAttribute('content', localStorage.getItem('description'))
    } else {
      document.querySelector('meta[name="description"]').setAttribute('content', localStorage.getItem('keywords'))
    }
    head[0].appendChild(meta)
  },
  methods: {
    // 获取面包屑信息
    getContent() {
      getContent(this.$route.query.id).then((res) => {
        this.formInfo = res.data.data.language.onlineMessage
        const index = res.data.fullName.indexOf('/')
        this.parentTitle = res.data.fullName.slice(0, index)
        this.activeTitle = res.data.name
        this.summary = res.data.summary
        this.languageId = res.data.languageId
      })
    },
    // 获取贴片
    async getModule() {
      await getModule(this.$route.query.id).then((res) => {
        this.data = res.data
      })
    },
    async getCode() {
      this.loading = true
      await getCaptcha().then((res) => {
        this.loading = false
        this.src = res.data.imageBase64
        this.token = res.data.token
      })
    },
    async getData() {
      this.loading = true
      await getCategory(this.$route.query.languageId).then((res) => {
        this.loading = false
        this.messageTypeList = res.data
      })
    },
    // 更换验证码
    handelChange() {
      this.getCode()
    },
    // 获取sts权限
    handleUpload() {
      if (this.form.verificationCode) {
        let obj = {
          token: this.token,
          captcha: this.form.verificationCode,
        }
        this.loading = true
        getStsInfo(obj)
          .then((res) => {
            this.loading = false
            res.data.fileName = 'online-message'
            getConfig(res.data)
            this.isShowBtn = 2
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this.$message.error('请先填写验证码!')
      }
    },
    // 获取上传文件
    getFile(file) {
      this.fileName = file.fileNames
      this.form.filePath = file.name
      this.form.fileUrl = file.res.requestUrls[0]
    },
    // 提交
    subClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.languageId = this.$route.query.languageId
          this.form.captcha = {
            token: this.token,
            captcha: this.form.verificationCode,
          }
          saveMessage(this.form).then((res) => {
            if (res.status === 200) {
              if (res.errorCode === 1) {
                this.$message.error(this.formInfo.captchaError || 'Captcha Fail')
                return
              }
              this.$refs.submitDig.open(res.data.uuid, this.formInfo)
              this.reset()
            }
          })
        } else {
          return false
        }
      })
    },
    // 重置
    reset() {
      this.isShowBtn = 1
      this.fileName = ''
      this.$refs.form.resetFields()
    },
    viewReply() {
      this.$refs.viewReply.open('1', this.formInfo)
    },
  },
  watch: {
    'form.verificationCode'(val) {
      if (!val) this.isShowBtn = 1
    },
  },
}
</script>
<style lang="less" scoped>
.onlineMessage {
  /deep/.el-breadcrumb {
    height: 30px;
    margin-bottom: 10px;
    color: #333;
    line-height: 26px;
  }
  /deep/.el-breadcrumb__inner {
    color: #333;
  }
  /deep/.el-breadcrumb__inner.is-link {
    font-weight: normal !important;
  }
  /deep/.el-button--danger {
    background: #d11a2d;
    border: 1px solid #d11a2d;
  }
  .lilineForm {
    /deep/.el-form-item__label {
      width: 100%;
      text-align: left;
      font-size: 18px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .verificationCode {
    .el-input {
      width: 40%;
      float: left;
    }
    img {
      width: 100px;
      display: inline-block;
      float: left;
      margin-left: 10px;
    }
    button {
      float: left;
      margin-left: 10px;
    }
  }
  .subBtn {
    margin-top: 38px;
    button {
      padding: 12px 50px;
    }
  }
  .uploadBtn {
    float: left;
    margin-left: 10px;
    margin-top: 40px;
  }

  @media (min-width: 768px) and (max-width: 992px) {
    .uploadBtn {
      float: left;
    }
  }
  @media (min-width: 992px) and (max-width: 1200px) {
    .uploadBtn {
      float: right;
    }
  }
  @media only screen and (min-width: 1200px) {
    .uploadBtn {
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs/onlineMessage.vue